import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, get, child } from "firebase/database";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../pages/css/LoginPage.css";
import login from '../images/hero-1.png';

// Toast config
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
});

export default function LoginPage() {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getDatabase();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check if user exists in users
      const userRef = ref(db, `blackstone-users/${user.uid}`);
      const adminRef = ref(db, `blackstone-admin/${user.uid}`);

      const userSnap = await get(userRef);
      const adminSnap = await get(adminRef);

      if (adminSnap.exists()) {
        // ✅ Admin user
        Toast.fire({
          icon: "success",
          title: "Welcome Admin! Redirecting to admin dashboard...",
        });
        navigate("/admin-dashboard");
      } else if (userSnap.exists()) {
        const status = userSnap.val().status;

        if (status === "Verified") {
          Toast.fire({
            icon: "success",
            title: "Login Successful! Redirecting to your dashboard...",
          });
          navigate("/user-dashboard");
        } else if (status === "NonVerified") {
          Toast.fire({
            icon: "info",
            title: "Your account is not verified.",
          });
          navigate("/dash");
        } else {
          Toast.fire({
            icon: "warning",
            title: "Unknown user status. Contact support.",
          });
        }
      } else {
        Toast.fire({
          icon: "error",
          title: "No user found with this account.",
        });
      }
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: `Invalid credentials. Please check your email and password.`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ backgroundColor: "#87CEEB" }} // Skyblue background
    >
      <div
        className="d-flex w-75 shadow-lg"
        style={{
          backgroundColor: "#fff",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        {/* Left section: full-width image */}
        <div className="w-50">
          <img
            src={login}
            alt="Login"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Right section: login form */}
        <div className="w-50 p-5 d-flex flex-column justify-content-center">
          <h2 className="fw-bold mb-2">Welcome Back!</h2>
          <p className="text-muted mb-4">
            Login with your email and password to continue
          </p>

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label className="fw-bold">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="formPassword">
              <Form.Label className="fw-bold">Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
            </Form.Group>

            <Button
              type="submit"
              className="w-100 gradient-btn border-0 py-2 fw-bold mb-3"
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Logging in...
                </>
              ) : (
                "Login"
              )}
            </Button>
          </Form>

          <p className="text-center mt-3">
            Don't have an account? <a href="/register">Sign Up</a>
          </p>
        </div>
      </div>

    </div>
  );
}
